<template>
    <div>
        <slot></slot>

        <transition name="slide-from-left">
            <modal v-if="showModal">
                <component v-bind:is="currentModalComponent" :data="modalData"></component>
            </modal>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showModal: false,
            modalData: null,
            currentModalComponent: null,
        }
    },
    created: function () {
        this.emitter.on('open-modal', (name, data) => {
            this.openModal(name, data)
        })
        this.emitter.on('close-modal', this.closeModal)
    },
    beforeUnmount() {
        this.emitter.off('open-modal')
        this.emitter.off('close-modal')
    },
    methods: {
        openModal: function (componentName, data) {
            this.currentModalComponent = componentName
            this.modalData = data
            this.showModal = true
        },
        closeModal: function () {
            this.showModal = false
        },
    },
}
</script>

<style lang="scss" scoped>
.slide-from-left-enter-active {
    transition: all 0.3s ease;
}

.slide-from-left-leave-active {
    transition: all 0.3s ease;
}

.slide-from-left-enter,
.slide-from-left-leave-to {
    transform: translateX(-100%);
}
</style>
